export const listStyles = {
  width: '100%',
  display: 'inline-grid',
  gap: '0.2rem 1rem',
  gridTemplateColumns: '1.25fr 1.75fr',
};
